import { PaymentAPI as r } from "../../../../../../js/payments/paymentApi.js";
import { Adapter as t, getAdapter as o } from "../../../adapter.js";
import { ShopSessionSettingsAdapter as i } from "./settings/settings.adapter.js";
import { ShopSessionCheckoutAdapter as n } from "./checkout/checkout.adapter.js";
import { ShopSessionDeliveryAdapter as p } from "./delivery/delivery.adapter.js";
import { ShopSessionConfigurationAdapter as s } from "./configuration/configuration.adapter.js";
import { ShopSessionModel as c } from "./shopSession.model.js";
import { ShopSessionServiceAdapter as m } from "./service/service.adapter.js";
import { ShopSessionLandingAdapter as h } from "./landing/landing.adapter.js";
class P extends t {
  adapt(e) {
    return new c({
      id: e.id,
      locationId: e.location_id,
      status: e.status,
      settings: o(i).adapt(e.settings),
      checkout: o(n).adapt(e.checkout),
      delivery: e != null && e.delivery ? o(p).adapt(e.delivery) : void 0,
      configuration: e.configuration ? o(s).adapt(e.configuration) : void 0,
      service: e.service ? o(m).adapt(e.service) : void 0,
      landing: e.landing ? o(h).adapt(e.landing) : void 0,
      ospaVersion: (e == null ? void 0 : e.ospaVersion) || 100,
      // 100 fallback version
      timezone: (e == null ? void 0 : e.timezone) || void 0
    });
  }
  serialize(e) {
    return {
      id: e.id,
      settings: o(i).serialize(e.settings),
      checkout: e.checkout ? {
        shop_ticket: {
          payment: {
            cheerfy_pay_payment_method_type: r.convertPaymentMethodTypeToTicketPaymentType(
              e.checkout.shopTicket.payment.cheerfyPayPaymentMethodType
            )
          }
        }
      } : void 0
    };
  }
}
export {
  P as ShopSessionAdapter
};
//# sourceMappingURL=shopSession.adapter.js.map
